/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesNl = {
  privacy: {
    pageTitle: "Privacybeleid",
    lastUpdated: "Laatst bijgewerkt: 1 juni 2026",
    introduction: {
      title: "Inleiding",
      body: "WasOK is een lokaal-eerst winkelhulp-app die gebruikers helpt zich te herinneren welke producten ze eerder hebben gekocht, beoordeeld of gerecenseerd.\n\nDit privacybeleid legt uit welke informatie wordt verwerkt bij gebruik van de app, hoe gegevens worden opgeslagen en hoe bepaalde diensten van derden kunnen werken.",
    },
    dataStored: {
      title: "Gegevens die door de app worden opgeslagen",
      body: "WasOK slaat de volgende informatie lokaal op uw apparaat op:\n\n• gescande productbarcodes\n• productnamen en details die door de gebruiker zijn ingevoerd\n• beoordelingen en opmerkingen\n• boodschappenlijsten\n• productcategorieën\n• prijzen en winkelinformatie\n• product- en winkelfoto's\n\nUw productgegevens en foto's worden niet naar WasOK-servers geüpload.",
    },
    permissions: {
      title: "Gebruikte machtigingen",
      camera: {
        title: "Camera",
        body: "Cameratoegang wordt gebruikt voor:\n\n• barcodes scannen\n• productfoto's maken",
      },
      photos: {
        title: "Foto's en media",
        body: "Toegang tot foto's of de galerij wordt alleen gebruikt wanneer:\n\n• u afbeeldingen aan producten toevoegt\n• u back-ups met foto's herstelt",
      },
      files: {
        title: "Bestands- en opslagtoegang",
        body: "Bestandstoegang kan worden gebruikt voor:\n\n• het exporteren van back-upbestanden\n• het importeren van door de gebruiker geselecteerde back-ups\n• het delen van boodschappenlijsten of back-ups",
      },
    },
    backup: {
      title: "Back-up- en exportfuncties",
      body: "WasOK stelt gebruikers in staat back-upbestanden te maken met app-gegevens en optionele foto's.\n\nBack-upbestanden worden lokaal op uw apparaat aangemaakt en kunnen worden opgeslagen of gedeeld via diensten die de gebruiker kiest, zoals:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokale apparaatopslag\n\nWasOK uploadt geen back-ups naar eigen servers.",
      onlineProductLookup: {
        title: "Online productopzoeking",
        body: "Wanneer u online barcode-opzoeking inschakelt in Voorkeuren, kan WasOK alleen het gescande barcodenummer naar openbare productdatabases sturen (zoals Open Food Facts) om een productnaam en merk voor te stellen. WasOK uploadt voor deze functie geen beoordelingen, opmerkingen, foto's, boodschappenlijsten, categorieën, winkelinformatie of back-upgegevens. U kunt dit op elk moment uitschakelen in Voorkeuren.",
      },
    },
    advertising: {
      title: "Advertenties en diensten van derden",
      intro:
        "WasOK gebruikt geselecteerde diensten van derden om bepaalde functies te bieden.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob wordt gebruikt om advertenties in de app weer te geven.\n\nGoogle en zijn partners kunnen informatie verwerken zoals:\n\n• advertentie-identifiers\n• apparaatinformatie\n• IP-adres\n• diagnostische en gebruiksgegevens\n\nGebruikers in bepaalde regio's kunnen om toestemming worden gevraagd voordat gepersonaliseerde advertenties worden getoond.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK gebruikt Firebase Crashlytics om crashes te identificeren en de stabiliteit van de app te verbeteren.\n\nCrashrapporten kunnen technische informatie bevatten zoals:\n\n• apparaatmodel\n• versie van het besturingssysteem\n• app-versie\n• crashdiagnostiek\n\nCrashrapporten bevatten opzettelijk geen productbeoordelingen, notities, boodschappenlijsten of foto's.",
      },
      externalProductDatabases: {
        title: "Externe productdatabases",
        body: "De barcode-opzoekfunctie kan externe productdatabases gebruiken om productinformatie op te halen.\n\nRaadpleeg voor meer informatie de privacybeleiden van de betreffende aanbieders.",
      },
    },
    dataSecurity: {
      title: "Gegevensbeveiliging",
      body: "WasOK slaat app-gegevens lokaal op uw apparaat op met behulp van opslagmechanismen van het besturingssysteem.\n\nHoewel redelijke maatregelen worden genomen om lokale app-gegevens te beschermen, is geen enkele methode van elektronische opslag volledig veilig.\n\nGebruikers zijn zelf verantwoordelijk voor het bijhouden van back-ups van belangrijke gegevens indien gewenst.",
    },
    children: {
      title: "Privacy van kinderen",
      body: "WasOK is niet gericht op kinderen onder de 13 jaar.",
    },
    notifications: {
      title: "Meldingen",
      body: "WasOK kan optioneel lokale meldingen op uw apparaat maken om u eraan te herinneren producten na aankoop te beoordelen.\n\nDeze meldingen worden lokaal op uw apparaat gegenereerd en gepland en vereisen geen account of externe server.\n\nU kunt meldingen op elk moment uitschakelen via de apparaatinstellingen of in de app, indien ondersteund.",
    },
    yourControl: {
      title: "Uw controle over gegevens",
      body: "U kunt:\n\n• opgeslagen producten op elk moment bewerken of verwijderen\n• app-gegevens van uw apparaat wissen\n• de app verwijderen\n• back-ups van uw gegevens exporteren",
    },
    changes: {
      title: "Wijzigingen in dit beleid",
      body: "Dit privacybeleid kan van tijd tot tijd worden bijgewerkt.\n\nWijzigingen gaan in wanneer de bijgewerkte versie wordt gepubliceerd.",
    },
    contact: {
      title: "Contact",
      body: "Als u vragen heeft over dit privacybeleid, neem dan contact op met:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Servicevoorwaarden",
    lastUpdated: "Laatst bijgewerkt: 1 juni 2026",
    acceptance: {
      title: "Aanvaarding van de voorwaarden",
      body: "Door WasOK te downloaden, te installeren of te gebruiken, gaat u akkoord met deze servicevoorwaarden.\n\nAls u niet akkoord gaat met deze voorwaarden, mag u de app niet gebruiken.",
    },
    license: {
      title: "Licentie",
      body: "WasOK verleent u een beperkte, niet-exclusieve, niet-overdraagbare, herroepbare licentie om de app te gebruiken in overeenstemming met deze voorwaarden.",
    },
    acceptableUse: {
      title: "Aanvaardbaar gebruik",
      body: "U stemt ermee in om niet:\n\n• de app te misbruiken\n• de werking van de app te verstoren\n• te proberen de app te reverse-engineeren of te wijzigen\n• de app te gebruiken in strijd met toepasselijke wet- of regelgeving",
    },
    localData: {
      title: "Lokale gegevens en back-ups",
      body: "WasOK slaat gebruikersgegevens lokaal op het apparaat op.\n\nGebruikers zijn zelf verantwoordelijk voor het bijhouden van back-ups van belangrijke gegevens indien gewenst.\n\nHoewel back-up- en herstelfunctionaliteit beschikbaar kan zijn, garandeert WasOK geen bescherming tegen verlies, beschadiging of uitval van opgeslagen gegevens.",
    },
    advertisements: {
      title: "Advertenties",
      body: "De app kan advertenties weergeven van advertentiepartners van derden, waaronder Google AdMob.",
    },
    noWarranty: {
      title: "Geen garantie",
      body: "WasOK wordt geleverd \"zoals het is\" en \"zoals beschikbaar\" zonder garanties van welke aard dan ook, uitdrukkelijk of stilzwijgend.\n\nWij garanderen niet dat:\n\n• de app altijd beschikbaar is\n• de app foutloos is\n• er nooit gegevensverlies optreedt\n• alle functies ononderbroken werken op alle apparaten",
    },
    limitationLiability: {
      title: "Beperking van aansprakelijkheid",
      body: "Voor zover wettelijk toegestaan zijn WasOK en de ontwikkelaars niet aansprakelijk voor:\n\n• gegevensverlies\n• winstderving\n• apparaatproblemen\n• indirecte of gevolgschade\n• onderbrekingen door gebruik of onvermogen om de app te gebruiken",
    },
    thirdParty: {
      title: "Diensten van derden",
      body: "Bepaalde functies of inhoud kunnen afhankelijk zijn van diensten van derden, waaronder advertentieaanbieders en externe opslag-/deeldiensten die door de gebruiker zijn geselecteerd.\n\nWasOK is niet verantwoordelijk voor diensten van derden of hun beleidslijnen.",
    },
    productInformation: {
      title: "Productinformatie",
      body: "Bepaalde productdetails kunnen worden verkregen via barcode-opzoekdiensten van derden.\n\nWasOK garandeert niet de nauwkeurigheid, volledigheid, beschikbaarheid of geschiktheid van informatie van externe gegevensbronnen.\n\nGebruikers moeten productinformatie waar nodig zelf verifiëren.",
    },
    changesApp: {
      title: "Wijzigingen aan de app",
      body: "WasOK kan op elk moment zonder voorafgaande kennisgeving worden gewijzigd, bijgewerkt, opgeschort of beëindigd.",
    },
    changesTerms: {
      title: "Wijzigingen in deze voorwaarden",
      body: "Deze voorwaarden kunnen periodiek worden bijgewerkt.\n\nVoortgezet gebruik van de app nadat updates van kracht zijn geworden, betekent aanvaarding van de herziene voorwaarden.",
    },
    contact: {
      title: "Contact",
      body: "Voor vragen over deze voorwaarden, neem contact op met:\n\nsupport@wasok.app",
    },
  },
};
